const LenderActivity = () => (
  <h3>Activity</h3>
);

export default LenderActivity;
